module.exports = __webpack_public_path__ + "static/media/crockpot.af82e98a.png";